/**
 * Formata um CNPJ removendo caracteres não numéricos e aplicando a máscara XX.XXX.XXX/XXXX-XX
 * @param {string} cnpj 
 * @returns {string}
 */
export const formatCNPJ = (cnpj) => {
  if (!cnpj) return '';
  const numbers = cnpj.replace(/\D/g, '');
  if (numbers.length === 14) {
    return numbers.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  }
  return cnpj;
};

/**
 * Normaliza o nome do dia da semana (remove acentos, coloca em minúsculo e mapeia abreviações)
 * @param {string|number} dia 
 * @returns {string}
 */
export const normalizeDayName = (dia) => {
  if (dia == null) return '';
  
  const mapNome = {
    'domingo': 'domingo', 'dom': 'domingo',
    'segunda': 'segunda', 'seg': 'segunda',
    'terca': 'terca', 'ter': 'terca',
    'quarta': 'quarta', 'qua': 'quarta',
    'quinta': 'quinta', 'qui': 'quinta',
    'sexta': 'sexta', 'sex': 'sexta',
    'sabado': 'sabado', 'sab': 'sabado'
  };

  if (typeof dia === 'string') {
    const nomeLower = dia.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return mapNome[nomeLower] || nomeLower;
  }
  
  return String(dia);
};
